import { MatDialogModule } from '@angular/material/dialog';
import { Component } from '@angular/core';
import { ButtonModule } from '@app/components/button/button.module';
import { ButtonPadding } from '@app/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pl-modal-contact-us',
  templateUrl: './modalContactUs.component.html',
  standalone: true,
  imports: [MatDialogModule, ButtonModule, TranslateModule],
})
export class ModalContactUsComponent {
  public readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;
}
